module.exports = __webpack_public_path__ + "img/setting.b394db04.svg";